"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _VirtualBackgroundUpload = require("./VirtualBackgroundUpload.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _utils = require("../../../utils");
var _containers = require("../../../containers");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var _useBackgroundFilterPageActionsApi = require("@studio/metrics/client/react/useBackgroundFilterPageActionsApi");
var _Reusable = require("../../../constants/Reusable");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function VirtualBackgroundUpload(_ref) {
  var uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    virtualBackground = _ref.virtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    isCustomBackgroundProcessing = _ref.isCustomBackgroundProcessing,
    updateUserBackground = _ref.updateUserBackground;
  var inputFile = (0, _react.useRef)(null);
  var uploadZone = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFileDragOver = _useState2[0],
    setIsFileDragOver = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    errorFile = _useState4[0],
    setErrorFile = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isUploading = _useState6[0],
    setIsUploading = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    uploadedFileName = _useState8[0],
    setUploadedFileName = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = (0, _slicedToArray2["default"])(_useState9, 2),
    isSoftDeleted = _useState0[0],
    setIsSoftDeleted = _useState0[1];
  var _useBackgroundFilterP = (0, _useBackgroundFilterPageActionsApi.useBackgroundFilterPageActionsApi)(),
    startAttendeeUploadedUserBackground = _useBackgroundFilterP.startAttendeeUploadedUserBackground,
    endAttendeeUploadedUserBackground = _useBackgroundFilterP.endAttendeeUploadedUserBackground;
  var _ref2 = virtualBackground || {},
    imageURL = _ref2.imageURL,
    fileName = _ref2.fileName,
    isUploadFailed = _ref2.isUploadFailed;
  var isBackgroundUploaded = !!imageURL;
  var hasActiveBackground = isBackgroundUploaded && !isSoftDeleted;
  var fileNameRef = (0, _react.useRef)(null);
  var backgroundUploadSuccessful = isBackgroundUploaded && isUploading;
  (0, _react.useEffect)(function () {
    if (backgroundUploadSuccessful) {
      endAttendeeUploadedUserBackground();
      setIsUploading(false);
      setIsSoftDeleted(false);
      updateUserBackground(_VirtualBackground.BACKGROUND_OPTIONS.CUSTOM);
    }
  }, [backgroundUploadSuccessful]);
  (0, _react.useEffect)(function () {
    if (hasActiveBackground) {
      var _fileNameRef$current;
      (_fileNameRef$current = fileNameRef.current) === null || _fileNameRef$current === void 0 || _fileNameRef$current.focus();
    }
    if (virtualBackground !== null && virtualBackground !== void 0 && virtualBackground.isDeleteFailed) {
      setIsSoftDeleted(false);
    }
  }, [isBackgroundUploaded, virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.isDeleteFailed, isSoftDeleted]);
  (0, _react.useEffect)(function () {
    if (isUploadFailed) {
      endAttendeeUploadedUserBackground({
        error: "Error uploading virtual background"
      });
      setIsUploading(false);
      setErrorFile({
        name: uploadedFileName,
        errors: [_VirtualBackground.UPLOAD_VIRTUAL_BACKGROUND_FAILURE_MSG]
      });
      resetUserVirtualBackground();
    }
  }, [isUploadFailed]);
  var handleFileChange = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(files) {
      var file, errors;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setErrorFile(null);
            if (!(files.length > 1)) {
              _context.next = 1;
              break;
            }
            console.warn(_VirtualBackground.ERROR_TITLE, _VirtualBackground.ERROR_DESCRIPTION);
            setErrorFile({
              name: 'Multiple Files...',
              errors: [_VirtualBackground.ERROR_DESCRIPTION]
            });
            setIsFileDragOver(false);
            return _context.abrupt("return");
          case 1:
            file = files[0];
            setUploadedFileName(file.name);
            _context.next = 2;
            return (0, _utils.validateVirtualBackgroundUpload)(file, files[0].length);
          case 2:
            errors = _context.sent;
            if (!(errors.length > 0)) {
              _context.next = 3;
              break;
            }
            console.warn(_VirtualBackground.ERROR_TITLE, {
              name: file.name,
              error: errors
            });
            setErrorFile({
              name: file.name,
              errors: errors
            });
            setIsFileDragOver(false);
            return _context.abrupt("return");
          case 3:
            if (isSoftDeleted) {
              resetUserVirtualBackground();
            }
            setIsUploading(true);
            startAttendeeUploadedUserBackground({
              fileName: file.name,
              fileSize: file.size
            });
            uploadUserVirtualBackground(file);
            setIsFileDragOver(false);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFileChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  function handleButtonClick() {
    inputFile.current.click();
    uploadZone.current.focus();
  }
  function handleDragOver(event) {
    event.preventDefault();
    if (hasActiveBackground || isUploading) {
      event.preventDefault();
      setIsFileDragOver(false);
      return;
    }
    setIsFileDragOver(true);
  }
  function handleDrop(event) {
    event.preventDefault();
    if (hasActiveBackground || isUploading) {
      setIsFileDragOver(false);
      return;
    }
    var droppedFiles = event.dataTransfer.files;
    if (!droppedFiles.length) {
      setIsFileDragOver(false);
    } else {
      handleFileChange(droppedFiles);
    }
  }
  function removeFile() {
    var _uploadZone$current2;
    if (errorFile) {
      var _uploadZone$current;
      setErrorFile(null);
      setIsUploading(false);
      (_uploadZone$current = uploadZone.current) === null || _uploadZone$current === void 0 || _uploadZone$current.focus();
      return;
    }
    setIsSoftDeleted(true);
    setIsUploading(false);
    updateUserBackground(_VirtualBackground.BACKGROUND_OPTIONS.CUSTOM, '');
    (_uploadZone$current2 = uploadZone.current) === null || _uploadZone$current2 === void 0 || _uploadZone$current2.focus();
  }
  var isErrorState = !!errorFile;
  var uploadZoneContent;
  if (hasActiveBackground) {
    uploadZoneContent = /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.FileDetailWrapper, {
      ref: fileNameRef,
      tabIndex: 0,
      "aria-disabled": isCustomBackgroundProcessing
    }, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.FileNameLabel, {
      "aria-label": "Uploaded file: ".concat(fileName)
    }, fileName), /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.DeleteIconWrapper, {
      tabIndex: 0,
      "aria-label": "Delete",
      onKeyDown: function onKeyDown(e) {
        return (0, _Reusable.handleEnterDown)(e, removeFile);
      },
      onClick: removeFile,
      "data-testid": "deleteFileIcon"
    }, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.DeleteIcon, {
      icon: _freeSolidSvgIcons.faXmark
    })));
  } else if (isErrorState) {
    uploadZoneContent = /*#__PURE__*/_react["default"].createElement(_containers.VirtualBackgroundUploadError, {
      id: "virtualBackgroundUploadError",
      role: "alert",
      errorFile: errorFile,
      removeFile: removeFile
    });
  } else {
    uploadZoneContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.UploadInfoText, {
      id: "uploadInstructions"
    }, _VirtualBackground.UPLOAD_INFO.SUPPORTED_FILE_TYPES, /*#__PURE__*/_react["default"].createElement("br", null), _VirtualBackground.UPLOAD_INFO.RECOMMENDED_SIZE), /*#__PURE__*/_react["default"].createElement("label", {
      id: "virtualFileLabel",
      htmlFor: "virtualBackgroundFile",
      className: "visually-hidden",
      "aria-hidden": "true"
    }, "Upload Virtual Background"), /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.HiddenInputFile, {
      type: "file",
      id: "virtualBackgroundFile",
      accept: ".png, .jpeg, .jpg",
      onChange: function onChange(e) {
        handleFileChange(e.target.files);
      },
      name: "file",
      "data-testid": "virtualBackgroundFileInput",
      ref: inputFile
    }), /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.StyledButton, {
      disabled: isFileDragOver || isUploading,
      onClick: handleButtonClick,
      "data-testid": "virtualBackgroundButtonInput",
      isUploading: isUploading
    }, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.ButtonContentWrapper, null, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.UploadIconWrapper, null, /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.UploadIcon, {
      icon: isUploading ? _freeSolidSvgIcons.faSpinner : _freeSolidSvgIcons.faUpload,
      spin: isUploading,
      isUploading: isUploading
    })), /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.UploadText, {
      isUploading: isUploading
    }, "Upload"))));
  }
  return /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundUpload.UploadZone, {
    ref: uploadZone,
    "data-testid": "virtualBackgroundUploadZone",
    onDragOver: handleDragOver,
    onDrop: handleDrop,
    onDragEnter: function onDragEnter() {
      return setIsFileDragOver(true);
    },
    onDragLeave: function onDragLeave() {
      return setIsFileDragOver(false);
    },
    isFileDragOver: isFileDragOver,
    isBackgroundUploaded: hasActiveBackground,
    tabIndex: 0,
    isError: isErrorState,
    "aria-describedby": isErrorState ? 'virtualBackgroundUploadError' : null
  }, uploadZoneContent);
}
VirtualBackgroundUpload.propTypes = {
  uploadUserVirtualBackground: _propTypes["default"].func,
  virtualBackground: _propTypes["default"].object,
  resetUserVirtualBackground: _propTypes["default"].func,
  isCustomBackgroundProcessing: _propTypes["default"].bool,
  updateUserBackground: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = VirtualBackgroundUpload;